import { withStyles, Box } from 'vopay';
import { Button, MaterialSymbol, Title } from 'UI';
import styles from './DefaultFundingMethods.module.scss';

const cn = withStyles(styles);

type MaterialSymbolIcon = React.ComponentProps<typeof MaterialSymbol>['icon'];

export type FundingMethodEmptyStateProps = {
  icon: MaterialSymbolIcon;
  title: string;
  description: string;
  actionLabel: string;
  actionIcon: MaterialSymbolIcon;
  onClickAction: () => void;
};

export default function FundingMethodEmptyState({
  icon,
  title,
  description,
  actionLabel,
  actionIcon,
  onClickAction,
}: FundingMethodEmptyStateProps) {
  return (
    <div className={cn('emptyState')}>
      <div className={cn('thumbnail', 'emptyStateThumbnail')}>
        <MaterialSymbol icon={icon} size="32px" />
      </div>
      <Box flx="col" gapSize="4px" jc="center" grow="1">
        <Title level="6">{title}</Title>
        <span className={cn('emptyStateDescription')}>{description}</span>
      </Box>
      <Button id="funding-method-empty-action" iconLeft={actionIcon} onClick={onClickAction}>
        {actionLabel}
      </Button>
    </div>
  );
}
